import * as API from '@/api';

export const feature = {
  state: {
    homeFeatures: [],
    feature: {
      data: {
        artworks: [],
      }
    },
  },
  getters: {
    homeFeatures(state) {
      return state.homeFeatures;
    },
    feature(state) {
      return state.feature;
    },
  },
  mutations: {
    setHomeFeatures(state, payload) {
      return state.homeFeatures = payload;
    },
    setFeature(state, payload) {
      return state.feature = payload;
    },
  },
  actions: {
    async getHomeFeatures({ commit }) {
      const features = await API.GET(`/home/features`);
      const areOnFeatures = features.data.data.filter(feature => feature.is_on);

      commit('setHomeFeatures', areOnFeatures)
    },
    async getFeature({ commit }, featureId) {
      const feature = await API.GET(`/home/features/${featureId}`);

      commit('setFeature', feature)
    },

  },
}